// angular
import { Injectable } from '@angular/core';

// addons
import { Observable } from 'rxjs';

// services
import { ApiService } from './api.service';

// models
import { IUserBalance } from '@shared/models';

@Injectable()
export class UserService {
  constructor(
    private apiService: ApiService
  ) {}

  getUserBalance(): Observable<IUserBalance> {
    return this.apiService.get('/balance');
  }
}
